import React from "react";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box, Typography } from "@mui/material";

const ExamDetailsColumns = [
  {
    field: "centerCode",
    headerName: "Code",
    flex: 1,
    minWidth: 100,
    renderCell: (params) => (
      <Typography sx={{ fontWeight: 500, color: '#1e293b', fontSize: '0.875rem' }}>
        {params.value}
      </Typography>
    )
  },
  {
    field: "centerName",
    headerName: "Center Name",
    flex: 2,
    minWidth: 180,
    renderCell: (params) => (
      <Typography sx={{ fontWeight: 700, color: '#0f172a', fontSize: '0.875rem' }}>
        {params.value}
      </Typography>
    )
  },
  {
    field: "examCity", 
    headerName: "City",
    flex: 1.5,
    renderCell: (params) => (
      <Typography sx={{ color: '#64748b', fontSize: '0.875rem' }}>
        {params.value || "N/A"}
      </Typography>
    )
  },
  {
    field: "totalStudents",
    headerName: "Total",
    width: 90,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography sx={{ fontWeight: 600, color: '#374151', fontSize: '0.875rem' }}>
        {params.value} 
      </Typography>
    )
  },
  {
    field: "presentStudents",
    headerName: "Present",
    width: 90,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography sx={{ fontWeight: 600, color: '#2563eb', fontSize: '0.875rem' }}>
        {/* Reverted to Math.abs logic */}
        {Math.abs(params.value || 0)} 
      </Typography>
    )
  },
  {
    field: "attendedStudents",
    headerName: "Attended",
    width: 100,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography sx={{ fontWeight: 600, color: '#059669', fontSize: '0.875rem' }}>
        {/* Reverted to Math.abs logic */}
        {Math.abs(params.value || 0)} 
      </Typography>
    )
  },
  {
    field: "rate",
    headerName: "Rate",
    width: 100,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => {
      // Use absolute values for the percentage calculation
      const present = Math.abs(params.row.presentStudents || 0);
      const total = params.row.totalStudents || 0;
      const rateVal = total > 0 ? (present / total) * 100 : 0;
      
      let color = "#dc2626"; 
      if (rateVal >= 80) color = "#16a34a"; 
      else if (rateVal >= 40) color = "#d97706"; 

      return (
        <Typography sx={{ fontWeight: 700, color, fontSize: '0.875rem' }}>
          {rateVal.toFixed(1)}%
        </Typography>
      );
    }
  },
  {
    field: "centerStatus",
    headerName: "Status",
    width: 130,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => {
      // Logic Fix: Compare absolute values to determine Mismatch
      const present = Math.abs(params.row.presentStudents || 0);
      const attended = Math.abs(params.row.attendedStudents || 0);
      const isMismatched = present !== attended;
      
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <Box sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            px: 1.5,
            py: 0.5,
            borderRadius: '20px', 
            fontSize: '0.75rem',
            fontWeight: 700,
            height: '120%',
            border: '1px solid',
            ...(isMismatched ? {
              bgcolor: '#fef3c7', color: '#c2410c', borderColor: '#fed7aa'
            } : {
              bgcolor: '#ecfdf5', color: '#047857', borderColor: '#d1fae5'
            })
          }}>
            {isMismatched ? <WarningAmberIcon sx={{ fontSize: 14 }} /> : <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />}
            {isMismatched ? "Mismatch" : "Synced"}
          </Box>
        </Box>
      );
    }
  }
];

export default ExamDetailsColumns;